// src/components/Hero.jsx
import React, { useRef, useEffect } from "react";

export default function Hero() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let animationId;
    const particles = [];
    const PARTICLE_COUNT = 80;
    const MAX_DISTANCE = 120;

    // Initialize particles with random positions & velocities
    const initParticles = () => {
      particles.length = 0;
      for (let i = 0; i < PARTICLE_COUNT; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          vx: (Math.random() - 0.5) * 0.5,
          vy: (Math.random() - 0.5) * 0.5,
          size: Math.random() * 3 + 1
        });
      }
    };

    // Draw gradient background
    const drawGradient = () => {
      const { width, height } = canvas;
      const grad = ctx.createLinearGradient(0, 0, width, height);
      grad.addColorStop(0, "#4f46e5");    // indigo-600
      grad.addColorStop(1, "#D7631F");    // FutureYX orange
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, width, height);
    };

    // Draw particles & connecting lines
    const drawParticles = () => {
      const { width, height } = canvas;

      // move and draw each particle
      particles.forEach(p => {
        p.x += p.vx;
        p.y += p.vy;
        // bounce off edges
        if (p.x < 0 || p.x > width) p.vx *= -1;
        if (p.y < 0 || p.y > height) p.vy *= -1;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(255,255,255,0.8)";
        ctx.fill();
      });

      // draw lines between close particles
      for (let i = 0; i < PARTICLE_COUNT; i++) {
        for (let j = i + 1; j < PARTICLE_COUNT; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const dist = Math.hypot(dx, dy);
          if (dist < MAX_DISTANCE) {
            ctx.strokeStyle = `rgba(255,255,255,${1 - dist / MAX_DISTANCE})`;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.stroke();
          }
        }
      }
    };

    // handle resize
    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      initParticles();
    };

    // animation loop
    const animate = () => {
      drawGradient();
      drawParticles();
      animationId = requestAnimationFrame(animate);
    };

    window.addEventListener("resize", resize);
    resize();
    animate();

    return () => {
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <section className="relative overflow-hidden">
      {/* Animated background */}
      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full" />
      {/* Foreground content */}
      <div className="relative container mx-auto px-4 py-32 text-center text-white">
        <h2 className="text-6xl font-extrabold mb-6">
          Secure IT Solutions & Mobile Apps
        </h2>
        <p className="text-xl mb-8">
          Cutting-edge, scalable, and resilient products designed for tomorrow.
        </p>
        <a
          href="/contact"
          className="inline-block bg-white text-indigo-600 font-semibold px-10 py-4 rounded-full hover:bg-gray-100 transition"
        >
          Let’s Talk Tech
        </a>
      </div>
    </section>
  );
}
